export default __webpack_public_path__ + "static/media/group.73a51c50.png";